import { render, staticRenderFns } from "@/modules/Contact/templates/contacts-list.html?vue&type=template&id=5a5f240e&scoped=true&"
import script from "@/modules/Contact/scripts/contacts-list.ts?vue&type=script&lang=js&"
export * from "@/modules/Contact/scripts/contacts-list.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Contact/styles/contacts-list.scss?vue&type=style&index=0&id=5a5f240e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5f240e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
